const initialState = {
    sourceConfigurations: [],
    sourceConfigurationsForSideBar: [],
    sourceConfig: {
        sourceName: '',
        referenceId: '',
        active: '',
        deletedIndex: '',
    },
    sourceNames: [],
    gridSourceConfigurations: {
        fielddata: [
            {
                header: 'Ref Id',
                inputfield: false,
                length: 10,
                name: 'ref_id',
                placeholder: 'e.g. Seq Id ',
            },
            {
                header: 'Source Name',
                inputfield: true,
                length: 10,
                name: 'source_name',
                placeholder: 'e.g. Name',
            },
            {
                header: 'Source Description',
                inputfield: true,
                length: 10,
                name: 'source_desc',
                placeholder: 'e.g. Desc',
            },
            {
                header: 'Active',
                inputfield: false,
                length: 1,
                name: 'active',
                placeholder: 'e.g. Y/N',
            },

            {
                header: 'Created date',
                inputfield: false,
                length: 1,
                name: 'created_date',
                placeholder: 'e.g Integer',
            },
        ],
        instances: [],
    },
    sourceFieldsSettings: {},
    unMappedDataDictionaries: [],
    mappedDataDictionaries: [],
    newUnMapForView: [],
    sourceColumns: [],
    targetColumns: [],
    viewSourceDictionaries: [],
};

export default initialState;